// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay_p8umw {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.3);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
}

.popupContainer_deGPm {
	background: white;
	border-radius: 8px;
	width: 400px;
	box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);
	padding: 20px;
}

.header_HdoQe {
	font-size: 18px;
	font-weight: 500;
	margin-bottom: 10px;
}

.textArea_nj4kU {
	width: 100%;
	height: 80px;
	border-radius: 4px;
	background: var(--f5-background);
	padding: 10px;
	font-size: 14px;
	resize: none;
	outline: none;
}

.charCounter_gVMZj {
	text-align: right;
	font-size: 12px;
	color: #999;
	margin-top: 5px;
}

.actions_VQecL {
	display: flex;
	justify-content: space-between;
	margin-top: 20px;
}

.cancelButton__y7CJ {
	background: none;
	border: none;
	color: #666;
	font-size: 14px;
	cursor: pointer;
	font-weight: 600;
}

.saveButton_Fkz9G {
	background-color: var(--_16c0982e-background);
	color: var(--white-color);
	padding: 8px 16px;
	border-radius: 4px;
	border: none;
	font-size: 14px;
	cursor: pointer;
	font-weight: 600;
}

.saveButton_Fkz9G:disabled {
	background-color: #aaa;
	cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/CalendarView/Calendar/components/CreateNewLocationPopup.module.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,8BAA8B;CAC9B,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,aAAa;AACd;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,YAAY;CACZ,2CAA2C;CAC3C,aAAa;AACd;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,gCAAgC;CAChC,aAAa;CACb,eAAe;CACf,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,iBAAiB;CACjB,eAAe;CACf,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,WAAW;CACX,eAAe;CACf,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,6CAA6C;CAC7C,yBAAyB;CACzB,iBAAiB;CACjB,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;CACtB,mBAAmB;AACpB","sourcesContent":[".overlay {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tbackground: rgba(0, 0, 0, 0.3);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tz-index: 1000;\n}\n\n.popupContainer {\n\tbackground: white;\n\tborder-radius: 8px;\n\twidth: 400px;\n\tbox-shadow: 0px 8px 16px rgba(0, 0, 0, 0.1);\n\tpadding: 20px;\n}\n\n.header {\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tmargin-bottom: 10px;\n}\n\n.textArea {\n\twidth: 100%;\n\theight: 80px;\n\tborder-radius: 4px;\n\tbackground: var(--f5-background);\n\tpadding: 10px;\n\tfont-size: 14px;\n\tresize: none;\n\toutline: none;\n}\n\n.charCounter {\n\ttext-align: right;\n\tfont-size: 12px;\n\tcolor: #999;\n\tmargin-top: 5px;\n}\n\n.actions {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-top: 20px;\n}\n\n.cancelButton {\n\tbackground: none;\n\tborder: none;\n\tcolor: #666;\n\tfont-size: 14px;\n\tcursor: pointer;\n\tfont-weight: 600;\n}\n\n.saveButton {\n\tbackground-color: var(--_16c0982e-background);\n\tcolor: var(--white-color);\n\tpadding: 8px 16px;\n\tborder-radius: 4px;\n\tborder: none;\n\tfont-size: 14px;\n\tcursor: pointer;\n\tfont-weight: 600;\n}\n\n.saveButton:disabled {\n\tbackground-color: #aaa;\n\tcursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `overlay_p8umw`,
	"popupContainer": `popupContainer_deGPm`,
	"header": `header_HdoQe`,
	"textArea": `textArea_nj4kU`,
	"charCounter": `charCounter_gVMZj`,
	"actions": `actions_VQecL`,
	"cancelButton": `cancelButton__y7CJ`,
	"saveButton": `saveButton_Fkz9G`
};
export default ___CSS_LOADER_EXPORT___;
